var _path, _path2, _path3, _path4, _g, _circle, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8555 18.4773V11.544C13.8555 8.99129 15.9249 6.92188 18.4776 6.92188H35.0528C36.2785 6.92188 37.454 7.40929 38.3206 8.27617L44.8564 14.8119C45.7233 15.6786 46.2107 16.854 46.2107 18.0798V43.8993C46.2107 46.452 44.1413 48.5214 41.5885 48.5214H18.4776C15.9249 48.5214 13.8555 46.452 13.8555 43.8993V41.5882",
    fill: "#3158F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8555 18.4773V11.544C13.8555 8.99129 15.9249 6.92188 18.4776 6.92188H35.0528C36.2785 6.92188 37.454 7.40929 38.3206 8.27617L44.8564 14.8119C45.7233 15.6786 46.2107 16.854 46.2107 18.0798V43.8993C46.2107 46.452 44.1413 48.5214 41.5885 48.5214H18.4776C15.9249 48.5214 13.8555 46.452 13.8555 43.8993V41.5882V18.4773Z",
    stroke: "#3158F2",
    strokeWidth: 3.46519,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6994_524555",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 5,
    width: 36,
    height: 46
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8555 18.4773V11.544C13.8555 8.99129 15.9249 6.92188 18.4776 6.92188H35.0528C36.2785 6.92188 37.454 7.40929 38.3206 8.27617L44.8564 14.8119C45.7233 15.6786 46.2107 16.854 46.2107 18.0798V43.8993C46.2107 46.452 44.1413 48.5214 41.5885 48.5214H18.4776C15.9249 48.5214 13.8555 46.452 13.8555 43.8993V41.5882",
    fill: "#848484"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8555 18.4773V11.544C13.8555 8.99129 15.9249 6.92188 18.4776 6.92188H35.0528C36.2785 6.92188 37.454 7.40929 38.3206 8.27617L44.8564 14.8119C45.7233 15.6786 46.2107 16.854 46.2107 18.0798V43.8993C46.2107 46.452 44.1413 48.5214 41.5885 48.5214H18.4776C15.9249 48.5214 13.8555 46.452 13.8555 43.8993V41.5882V18.4773Z",
    stroke: "#848484",
    strokeWidth: 3.46519,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6994_524555)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1421 18.4765H36.9673C35.691 18.4765 34.6562 17.4418 34.6562 16.1654V2.30078",
    fill: "#91A5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1421 18.4765H36.9673C35.691 18.4765 34.6562 17.4418 34.6562 16.1654V2.30078",
    stroke: "#91A5F2",
    strokeWidth: 3.46519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.1519,
    cy: 45.1519,
    r: 13.4019,
    fill: "#3158F2",
    stroke: "#F1F4F8",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0008 42.7178L47.2523 40.4662L49.5039 42.7178",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2498 47.2217L47.2498 40.4676",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3183 48.0264C52.3183 49.2699 51.3102 50.2779 50.0667 50.2779H44.4391C43.1956 50.2779 42.1875 49.2699 42.1875 48.0264",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.fd692d9274cb32e43cd6bb922e11fa92.svg";
export { ForwardRef as ReactComponent };